import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";

export interface IGetPassOfferRequestPayload {
  nonTripSearchCriteria: {
    validFrom: string;
    places: {
      stopPlaceRef: string;
      objectType: string;
    }[]
  },
  offerSearchCriteria: {
    productTags: string[];
    offerMode: string;
    currency: string;
  },
  anonymousPassengerSpecifications: {
    externalRef: string;
    type: string;
    cards: any[];
    age?: number;
    prmNeeds?: string[];
  }[]
}

export interface IPassOfferProduct {
  id: string;
  type: string;
  code: string;
  description: string;
  owner: string;
  condition: {
    type: string;
    description: string;
    shortDescription: string;
  }[],
  flexibility: string;
  serviceClass: {
    type: string;
    name: string;
  },
  travelClass: string;
  fulfillmentOptions: {
    type: string;
    media: string
  }[],
  carrierConstraintText: string;
  freeItemCount: number,
  descriptiveTexts: string[],
  productTags: string[]
}

export interface IPassOffer {
  offerId: string;
  summary: string;
  offerSummary: {
    minimalPrice: {
      vats?: {
        countryCode: string
        amount: number
        scale: number
        percentage: number
      }[]
      currency: string
      amount: number
      scale: number
    };
    minimalOriginalPrice: {
      currency: string;
      amount: number,
      scale: number
    },
    overallServiceClass: {
      type: string;
      name: string;
    };
    overallTravelClass: string;
    overallAccommodationType: string;
    overallFlexibility: string;
  },
  createdOn: string;
  preBookableUntil: string;
  passengerRefs: string[];
  products: IPassOfferProduct[];
  admissionOfferParts: {
    id: string;
    isReservationRequired: boolean;
    objectType: string;
    createdOn: string;
    validFrom: string;
    validUntil: string;
    price: {
      vats?: {
        countryCode: string
        amount: number
        scale: number
        percentage: number
      }[]
      currency: string
      amount: number
      scale: number
    },
    originalPrice: {
      currency: string;
      amount: number,
      scale: number
    },
    priceGuaranteedUntil: string;
    offerMode: string;
    passengerRefs: string[];
    refundable: string;
    exchangeable: string;
    products: { productId: string }[];
    availableFulfillmentOptions: {
      type: string;
      media: string;
    }[],
    appliedPassengerTypes: {
      passengerRef: string;
      type: string;
      description: string;
    },
    indicatedConsumption: {
      unit: {
        objectType: "DayTravelAccountUnit" | "TripTravelAccountUnit";
      },
      amount: number;
    }
  }[]
}

export interface IPassOfferResponse {
  offers: IPassOffer[];
  anonymousPassengerSpecifications: {
    externalRef: string;
    type: string;
    cards: any[];
  }[];
  trips: [];
  _links: [];
}

export const getPassOffers = async (offerPayload: IGetPassOfferRequestPayload) => {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getPassOffersAPI;

  return await apiRequest<IPassOfferResponse>(endpoint, 'POST', {
    body: JSON.stringify(offerPayload),
  });
}
